import React from "react";
import "../../../styles/LoadingSpinner.css";

function LoadingSpinner() {
  return (
    <div
      role="status"
      className="fixed inset-0 flex items-center justify-center bg-black/80 z-50 p-4"
    >
      <div className="w-full max-w-[700px] h-auto">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 700 150"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-auto"
        >
          <g id="darts" className="scale-100 origin-center">
            <g className="dart dart-animation">
              <image
                x="310"
                y="10"
                width="65"
                height="60"
                xlinkHref="/dart.png"
                transform="rotate(0 350 35)"
              />
            </g>
            <g className="dart dart-animation delayed-1">
              <image
                x="340"
                y="0"
                width="70"
                height="65"
                xlinkHref="/dart.png"
                transform="rotate(0 350 35)"
              />
            </g>
            <g className="dart dart-animation delayed-2">
              <image
                x="300"
                y="-10"
                width="65"
                height="60"
                xlinkHref="/dart.png"
                transform="rotate(0 350 35)"
              />
            </g>
          </g>
          {/* Message 1 */}
          <g opacity="0" className="scale-100 origin-center translate-x-0">
            <text
              x="240"
              y="70"
              className="text text-[22px] sm:text-[24px] font-medium"
            >
              Creating your Darts Twin
            </text>
            <animate
              attributeName="opacity"
              values="0;1;1;0"
              keyTimes="0;0.1;0.9;1"
              dur="3.2s"
              begin="0s"
              fill="freeze"
            />
            <g className="dots">
              <text x="505" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
              <text x="515" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
              <text x="525" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
            </g>
          </g>

          {/* Message 2 */}
          <g opacity="0" className="scale-100 origin-center translate-x-0">
            <text
              x="240"
              y="70"
              className="text text-[22px] sm:text-[24px] font-medium"
            >
              Simulating 10.000 Games
            </text>
            <animate
              attributeName="opacity"
              values="0;1;1;0"
              keyTimes="0;0.1;0.9;1"
              dur="3.2s"
              begin="3.2s"
              fill="freeze"
            />
            <g className="dots">
              <text x="517" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
              <text x="527" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
              <text x="537" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
            </g>
          </g>

          {/* Message 3 */}
          <g opacity="0" className="scale-100 origin-center translate-x-0">
            <text
              x="240"
              y="70"
              className="text text-[22px] sm:text-[24px] font-medium"
            >
              Calculating Results
            </text>
            <animate
              attributeName="opacity"
              values="0;1"
              dur="0.4s"
              begin="6.4s"
              fill="freeze"
            />
            <g className="dots">
              <text x="446" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
              <text x="456" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
              <text x="466" y="70" className="dot text-[22px] sm:text-[24px]">
                .
              </text>
            </g>
          </g>
        </svg>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default LoadingSpinner;
